// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1vIkw","label":"SetPasswdForm_label__3hqHw"};